// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__D3iGd","disabled":"styles_disabled__I4QAI"};